import { useContext, useEffect } from "react";

import { 
    LoadSavedQuotationsCard, 
    QuotationInfoContext,
    QuotationStep,
} from "../../../shared";
import { LOADING_SAVED_QUOTATIONS_STATES } from '../../../shared/interfaces/loading-saved-quotations-states-enum';

const {
    INIT_LOADING,
    STEP_THREE_DATA_FILLED,
    FINISH_LOADING,
} = LOADING_SAVED_QUOTATIONS_STATES;

export const LoadSavedCarQuotations = () => {
    const { 
        loadSaveQuotationState, 
        setLoadSaveQuotationState,
        setLoadingSavedQuotation,
        setCurrentStep,
    } = useContext(QuotationInfoContext);

    useEffect(() => {
        if(loadSaveQuotationState === STEP_THREE_DATA_FILLED) {
            setLoadSaveQuotationState(FINISH_LOADING);
            setLoadingSavedQuotation(false);
            setCurrentStep(QuotationStep.THREE);
        };
    }, [loadSaveQuotationState]);

    useEffect(() => {
        setLoadSaveQuotationState(INIT_LOADING);
        /* eslint-disable-next-line */
    }, []);

    return <LoadSavedQuotationsCard />;
};
